export default __webpack_public_path__ + "static/media/fragile.1026654d.png";